import {TechnicalDatasheetType} from './technical-datasheet-type.enum';

export class TechnicalDatasheet {
  public id: number;
  public name: string;
  public type: TechnicalDatasheetType;
  public imageId: string;

  public constructor(id: number, name: string, type: TechnicalDatasheetType, imageId: string) {
    this.id = id;
    this.name = name;
    this.type = type;
    this.imageId = imageId;
  }

  public static fromJSON(dataSheetJSON: any): TechnicalDatasheet {
    return new TechnicalDatasheet(dataSheetJSON.id, dataSheetJSON.name, dataSheetJSON.type, dataSheetJSON.imageId);
  }

  public toJSON(): JSON {
    return {
      id: this.id,
      name: this.name,
      type: this.type,
      imageId: this.imageId
    } as any as JSON;
  }
}
